import { StpViewerConfig } from './stp-viewer-config.model';

export class LatestItemsUsage {
    public stpViewerConfig: StpViewerConfig;
    constructor() {
        this.stpViewerConfig = new StpViewerConfig();
    }
}
